import { render, staticRenderFns } from "./PropertyViewer.vue?vue&type=template&id=d2175e5a&scoped=true&"
import script from "./PropertyViewer.vue?vue&type=script&lang=js&"
export * from "./PropertyViewer.vue?vue&type=script&lang=js&"
import style0 from "./PropertyViewer.vue?vue&type=style&index=0&id=d2175e5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2175e5a",
  null
  
)

export default component.exports